import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { Wallet, WalletTransaction } from "../../Schemas/Wallet";

interface Filter extends IFilterSchema {
  column: WalletListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: WalletListColumnSortable;
}

export enum WalletListColumnFilterable {
  BALANCE = "balance",
  CREATED_AT = "created_at",
  WORKSPACE_ID = "workspace_id",
  ID = "id"
}
export enum WalletListColumnSortable {
  WORKSPACE_ID = "workspace_id",
  ID="id",
  BALANCE = "balance",
  CREATED_AT = "created_at",
}

interface WalletTransactionListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

interface WalletChangePayloadBody {
  amount: number;
  description: string;
}

interface WalletTransactionListResponseBody extends IResponseBody {
  data: {
    wallets: Wallet[];
    total: number;
  };
}

export class WalletListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/wallets`;
  }

  async send(
    queryStrings?: WalletTransactionListQueryString
  ): Promise<WalletTransactionListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async increase(
    walletId: number,
    payload: WalletChangePayloadBody
  ): Promise<WalletTransactionListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/${walletId}/increase`,
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async decrease(
    walletId: number,
    payload: WalletChangePayloadBody
  ): Promise<WalletTransactionListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/${walletId}/decrease`,
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
